import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console for debugging
    console.error('Application Error Boundary caught an error:', error, errorInfo);
    
    // In production, you might want to log this to an error reporting service
    if (process.env.NODE_ENV === 'production') {
      // Example: Send to error reporting service
      // errorReportingService.captureException(error, { extra: errorInfo });
    }
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI for production
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '20px',
          fontFamily: 'Georgia, serif',
          backgroundColor: '#f9f7f4',
          textAlign: 'center'
        }}>
          <div style={{
            maxWidth: '600px',
            padding: '40px',
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
          }}>
            <h1 style={{ color: '#8B4513', marginBottom: '20px' }}>
              Khesed+ Avad Ministry
            </h1>
            <h2 style={{ color: '#8B4513', marginBottom: '20px' }}>
              Temporarily Unavailable
            </h2>
            <p style={{ color: '#5D4037', marginBottom: '30px', lineHeight: '1.6' }}>
              We're experiencing a temporary issue with our website. 
              Please try refreshing the page or contact us directly at{' '}
              <a href="mailto:Khesed.love.mercy@gmail.com" style={{ color: '#8B4513' }}>
                Khesed.love.mercy@gmail.com
              </a>
            </p>
            <button 
              onClick={() => window.location.reload()}
              style={{
                backgroundColor: '#8B4513',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '4px',
                fontSize: '16px',
                cursor: 'pointer',
                marginRight: '10px'
              }}
            >
              Refresh Page
            </button>
            <a 
              href="mailto:Khesed.love.mercy@gmail.com"
              style={{
                backgroundColor: '#D2B48C',
                color: '#8B4513',
                border: '2px solid #8B4513',
                padding: '10px 20px',
                borderRadius: '4px',
                fontSize: '16px',
                textDecoration: 'none',
                display: 'inline-block'
              }}
            >
              Contact Us
            </a>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;